const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogPerfilTurmaLeitura(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaLeitura`, params);
    },
    $obterRelatorioLogCSVPerfilTurmaLeitura(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaLeituraCsv`, params);
    },
    $obterRelatorioLogPDFPerfilTurmaLeitura(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaLeituraPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
